export const searchActionTypes = {
    SEARCH_CUSTOMER_RESULT : "SEARCH_CUSTOMER_RESULT",
    EMPTY_SEARCH_RESULTS: "EMPTY_SEARCH_RESULTS",
    SEARCH_INPUT_CHANGED: "SEARCH_INPUT_CHANGED",
    SEARCH_LOADING: "SEARCH_LOADING"
}